export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openCountryForm({commit}) {
        commit('openCountryForm');
    },
    closeCountryForm({commit}) {
        commit('closeCountryForm');
    },
    openCountyForm({commit}) {
        commit('openCountyForm');
    },
    closeCountyForm({commit}) {
        commit('closeCountyForm');
    },
    openCityForm({commit}) {
        commit('openCityForm');
    },
    closeCityForm({commit}) {
        commit('closeCityForm');
    }
}